export const sanitizeStyleValue = (value?: string | null): string => {
  if (!value) {
    return '';
  }
  return value.replace(/[^a-zA-Z]/g, '');
};
